<template>
  <div class="loader" transition="loader">
    <div class="animation">
      <sprite :images="images" :playing="!loaded"></sprite>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import Sprite from 'components/Sprite'
export default {
  name: 'Loader',
  components: {
    Sprite
  },
  data () {
    return {
      loaded: false,
      images: [
        require('src/assets/sprites/loader.png')
      ]
    }
  },
  transitions: {
    loader: {
      enter (el, done) {
        this.loaded = false
        // gsap.set(el, {opacity: 0})
        gsap.to(el, 0.5, {opacity: 1, onComplete: done})
      },
      leave (el, done) {
        this.loaded = true
        gsap.to(el, 0.5, {opacity: 0, delay: 0.1, onComplete: () => {
          done()
        }})
      }
    }
  },
  computed: {
    classes () {
      return this.loaded ? '' : 'load'
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
  background-color: inherit;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.animation {
  width: 288px;
  height: 288px;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// Loader.vue?2177c72a